import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useOrganizationSwitcher from '@/composables/useOrganizationSwitcher';

import Dropdown from '@/components/forms/Dropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSwitcher',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { currentOrganizationId, organizations, changeOrganization } =
  useOrganizationSwitcher();

const error = ref('');

async function selectOrganization(organization: any) {
  try {
    error.value = '';
    await changeOrganization(organization);
    window.location.reload();
  } catch (err: any) {
    error.value = err;
    throw err;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", null, _toDisplayString(_unref(websiteText)('mypages__shop_as').value), 1),
    _createVNode(Dropdown, {
      selectOptionHandler: selectOrganization,
      modelValue: _unref(currentOrganizationId),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentOrganizationId) ? (currentOrganizationId).value = $event : null)),
      options: _unref(organizations),
      shrinkOnSelect: false,
      class: "my-pages-menu-organization-switcher",
      searchPlaceholder: _unref(websiteText)('mypages__search_organization').value,
      enableSearch: true
    }, null, 8, ["modelValue", "options", "searchPlaceholder"])
  ], 64))
}
}

})